import React, { InputHTMLAttributes } from 'react';

import styled from 'styled-components';

interface SInputProps {
  error?: string;
  type?: string;
}

const SInput = styled.input<SInputProps>`
  width: 100%;
  border-radius: 4px;
  font-size: 15px;
  height: 44px;
  padding: 0px 16px;
  outline: none;
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield;
  }

  ${({
    theme: {
      global,
      ui: { input },
    },
    error,
  }) => ({
    color: global.textColor,
    backgroundColor: global.bgColor,
    border: `1px solid ${error ? global.errorColor : input.borderColor}`,
  })}
  text-align: ${(props) => (props.type === 'number' ? 'right' : 'left')};

  &:disabled {
    background-color: ${(props) => props.theme.ui.input.disabledBgColor};
  }

  &:focus {
    ${({ theme: { global }, error }) => ({
      border: `1px solid ${error ? global.errorColor : global.mainColor}`,
    })}
  }

  &::placeholder {
    color: ${(props) => props.theme.global.lightTextColor};
  }
`;

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

const Input = React.forwardRef((props: InputProps, ref: React.ForwardedRef<HTMLInputElement>) => {
  return <SInput ref={ref} {...props} />;
});

export default Input;
